import { isShortBookingReference } from "@majourneys/shared";

/**
 * A booking's own page, from the account (owner, 2026-10-26: "how can I
 * access the full reservation page from here").
 *
 * Only the full reference opens it, with the guest's details, cancel and
 * modify: the API looks a booking up by that, and refuses a short `MA-<digits>`
 * form. A row with no booking id on file is labelled `MJ-<reservation id>` by
 * `GET /me/reservations`, and that id is a UUID (a number in older tests): it
 * names no booking the page or the cancel service can find, so it gets null
 * and stays a plain row.
 */
const NO_REFERENCE = /^MJ-(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function hasFullBookingReference(ref: string | null | undefined): ref is string {
  if (!ref) return false;
  return !isShortBookingReference(ref) && !NO_REFERENCE.test(ref);
}

export function bookingPageHref(ref: string | null | undefined, lang: string): string | null {
  if (!hasFullBookingReference(ref)) return null;
  return `/${lang}/booking/${encodeURIComponent(ref)}/thank-you`;
}
